import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";

export function useActionItemPermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  const canAddActionItems = permissions.includes("casemanager.add_actionableitems");
  const canEditActionItems = permissions.includes("casemanager.change_actionableitems");
  const canDeleteActionItems = permissions.includes("casemanager.delete_actionableitems");
  const canViewFollowUps = permissions.includes("casemanager.can_view_follow_ups");

  return {
    canAddActionItems,
    canEditActionItems,
    canDeleteActionItems,
    canViewFollowUps,
  };
}
